/**
 * SectionHeader - Shared Component
 * 
 * Provides consistent page/section headers with title, optional subtitle,
 * and action buttons. Used across all sections.
 * 
 * Design System: Layout Pattern - Universal Page Structure
 */

import React from 'react';
import { motion } from 'framer-motion';

const SectionHeader = ({
  title,
  subtitle,
  actions, // Array of React elements (buttons, etc.)
  backButton, // { onClick: function, label: string }
  className = ''
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className={`mb-8 ${className}`}
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex-1">
          {backButton && (
            <button
              onClick={backButton.onClick}
              className="flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-3 transition-colors"
            >
              {backButton.icon || <span>←</span>}
              <span>{backButton.label || 'Back'}</span>
            </button>
          )}
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            {title}
          </h1>
          {subtitle && (
            <p className="text-sm sm:text-base text-gray-600 mt-1">
              {subtitle}
            </p>
          )}
        </div>
        {actions && actions.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {actions.map((action, index) => (
              <React.Fragment key={index}>{action}</React.Fragment>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default SectionHeader;
